module.exports = __webpack_public_path__ + "media/workplace/playlist-icon-97c1e811.svg";